import { defaultAuroraProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/aurora/default-constants';

export const TRISOLARIS_AURORA_CONTRACT_ADDRESS = '0x2CB45Edb4517d5947aFdE3BEAbF95A582506858B';

export const TRISOLARIS_AURORA_PROVIDER_CONFIGURATION = defaultAuroraProviderConfiguration;
